const adminPermission = [
    {"actions": ["view"],"subject": "/account"},
    {"actions": ["view"],"subject": "/profile"},
    {"actions": ["view"],"subject": "/transaction"},
    {"actions": ["view"],"subject": "/technicalService"},
    {"actions": ["view"],"subject": "intigration"},
    {"actions": ["view"],"subject": "/account/profile"},
    {"actions": ["view"],"subject": "/products"},
    {"actions": ["view"],"subject": "/admin"},
    {"actions": ["view"],"subject": "/admin/dashboard"},
    {"actions": ["view"],"subject": "/admin/users"},
    {"actions": ["view"],"subject": "/admin/report/transaction"},
    {"actions": ["view"],"subject": "/redmo"},
    {"actions": ["manage"],"subject": "users"}
];

const financePermission = [
    {"actions": ["view"],"subject": "/account"},
    {"actions": ["view"],"subject": "/profile"},
    {"actions": ["view"],"subject": "/transaction"},
    {"actions": ["view"],"subject": "/account/profile"},
    {"actions": ["view"],"subject": "/admin"},
    {"actions": ["view"],"subject": "/admin/dashboard"},
    {"actions": ["view"],"subject": "/admin/report/transaction"},
];

const merchantPermission = [
    {"actions": ["view"],"subject": "/account",},
    {"actions": ["view"],"subject": "/profile",},
    {"actions": ["view"],"subject": "/transaction"},
    {"actions": ["view"],"subject": "/account/profile"},
    {"actions": ["view"],"subject": "/technicalService"},
    {"actions": ["view"],"subject": "/products"},
    {"actions": ["view"],"subject": "intigration"},

];

const ceylincoPermission = [
    // {"actions": ["view"],"subject": "/transaction"},
    {"actions": ["view"],"subject": "/products"},
    {"actions": ["view"],"subject": "/account"},
    {"actions": ["view"],"subject": "/account/profile"}
];

const userPermission = [
    {"actions": ["view"],"subject": "/account"},
    {"actions": ["view"],"subject": "/account/profile"},
    {"actions": ["view"],"subject": "/transaction"}
];

const redmoAdminPermission = [
    {"actions": ["view"],"subject": "/account"},
    {"actions": ["view"],"subject": "/account/profile"},
    {"actions": ["view"],"subject": "/transaction"},
    {"actions": ["view"],"subject": "/products"},
    {"actions": ["view"],"subject": "/redmo"},
];

export default {adminPermission, userPermission, merchantPermission, ceylincoPermission, financePermission, redmoAdminPermission};